var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpaddressIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a5 5 0 00-5 5c0 5 5 11 5 11s5-6 5-11a5 5 0 00-5-5zm0 8.063a3.063 3.063 0 110-6.126 3.063 3.063 0 010 6.126zM6.063 5a1.938 1.938 0 113.876 0 1.938 1.938 0 01-3.876 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpaddressIcon);
export default __webpack_public_path__ + "static/media/ipaddress-icon.75b641f305527b2786d48dbeba2126e6.svg";
export { ForwardRef as ReactComponent };